<div class="banner_header">
    <div class="col-md-12">
        <h2> Payment Related Issue Form</h2>
    </div>
</div>

<div class="container download_section pad_btm_size">


    <div class="row">
        <div class="col-md-12">

            <div *ngIf="form1">
                <!-- main app container -->
                <div class="card m-3">
                    <h3 class="card-header">Payment Related Issue</h3>

                    <!-- {{bdnuForm.value | json}} -->
                    <div class="card-body" *ngIf="bool_bdnuForm">
                      <!-- <h2>SINGLE / BULK</h2> -->
                        <form [formGroup]="bdnuForm" (ngSubmit)="onSubmit()">
                            <div class="form-row">
                                <div class="col-md-4">
                                    <label style="display: block; text-align: left;">Type of Payment Done </label>
                                    <div style="text-align: left;">
                                        <input type="radio" value="radio1" formControlName="radiobtn"
                                            [(ngModel)]="readioSelected" (change)="showContent(readioSelected)" />
                                        <span> Bulk </span>
                                        <input type="radio" value="radio2" formControlName="radiobtn"
                                            [(ngModel)]="readioSelected" (change)="showContent(readioSelected)" />
                                        <span> Single </span>
                                        <input type="radio" value="radio3" formControlName="radiobtn"
                                            [(ngModel)]="readioSelected" (change)="showContent(readioSelected)" />
                                        <span> Direct NIMI Account </span>
                                    </div>
                                    <div *ngIf="submitted && f.radiobtn.errors" class="invalid-feedback">
                                        <div *ngIf="f.radiobtn.errors.required">
                                            Choose Your Payment Type
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="bulk_bool" class="form-group col-12">

                                    <div class="row">
                                        <div class="form-group col-6">
                                            <label>Number of Students <span class="clr_red"> * </span></label>
                                            <input type="text" formControlName="numberofstud" class="form-control"
                                                [ngModel]="numberStud" [ngClass]="{
                          'is-invalid': submitted && f.numberofstud.errors
                        }" maxlength="2" (keyup)="onKey($event)" (change)="test($event)" maxlength="3"
                                                placeholder="Enter Number of Students"
                                                (keypress)="omit_number($event)" />
                                            <div *ngIf="submitted && f.numberofstud.errors" class="invalid-feedback">
                                                <div *ngIf="f.numberofstud.errors.required">
                                                    Enter Number of Students
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-6">
                                            <label>Total Amount</label>
                                            <input [attr.disabled]='true' type="text" formControlName="amount"
                                                [(ngModel)]="totAmount" class="form-control" [ngClass]="{
                          'is-invalid': submitted && f.amount.errors
                        }" placeholder="Total Amount" />
                                            <div *ngIf="submitted && f.amount.errors" class="invalid-feedback">
                                                <div *ngIf="f.amount.required">
                                                    Enter Your Amount
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group col-12">
                                            <!-- <button class="btn btn-success" type="button"
                                                (click)="addQualification()">Add </button> -->
                                            <div class="table table-bordered" formArrayName="qualification"
                                                style="text-align: center;">

                                                <div *ngFor="let quantity of qualificationFormGroups; let i=index"
                                                    [formGroupName]="i">

                                                    <!-- Price: -->

                                                    <!-- <input type="text" formControlName="bukregno" class="form-control"
                                                    [ngClass]="{ 'is-invalid': submitted && f.singlerollno.errors }"
                                                    minlength="12" maxlength="12" placeholder="Enter Your Register Number"
                                                    (keypress)="omit_number($event)" />

                                                <div *ngIf="submitted && f.singlerollno.errors" class="invalid-feedback">
                                                    <div *ngIf="f.singlerollno.errors.required">
                                                        Enter Your Register Number
                                                    </div>
                                                </div> -->

                                                    <input type="text" formControlName="bukregno" class="form-control"
                                                        minlength="12" maxlength="12" (keypress)="omit_number($event)"
                                                        placeholder="Enter Your Register Number">
                                                    <p *ngIf="quantity.controls.bukregno.errors?.required" style="font-size: 80%;
                                                    color: #dc3545;">Enter Your Register Number
                                                    </p>

                                                    <p *ngIf="quantity.controls.bukregno.errors?.pattern" style="font-size: 80%;
                                                    color: #dc3545;">Enter Your Valid Register Number
                                                    </p>


                                                </div>
                                            </div>


                                            <!-- <label>Bulk Roll No</label>

                                            <textarea formControlName="bulkrollno" class="form-control" [ngClass]="{
                                                'is-invalid': submitted && f.bulkrollno.errors
                                              }" maxlength="500" rows="3" style="resize: none;">

                                              </textarea> -->

                                            <!--
                                            <div *ngIf="submitted && f.bulkrollno.errors" class="invalid-feedback">
                                                <div *ngIf="f.bulkrollno.errors.required">
                                                    Enter Your Register Number
                                                </div>
                                            </div> -->


                                        </div>

                                    </div>



                                </div>

                                <div *ngIf="single_bool" class="form-group col-12">
                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <label>Register Number <span class="clr_red"> * </span></label>

                                            <input type="text" formControlName="singlerollno" class="form-control"
                                                [ngClass]="{ 'is-invalid': submitted && f.singlerollno.errors }"
                                                minlength="12" maxlength="12" placeholder="Enter Your Register Number"
                                                (keypress)="omit_number($event)" />

                                            <div *ngIf="submitted && f.singlerollno.errors" class="invalid-feedback">
                                                <div *ngIf="f.singlerollno.errors.required">
                                                    Enter Your Registers Number
                                                </div>
                                                <div *ngIf="f.singlerollno.errors.pattern">
                                                    Enter Your 12 digit valid Register Number
                                                </div>
                        
                                            </div>

                                       



                                        </div>


                                    </div>

                                </div>
                            </div>

                            <hr>

                            <div class="form-row">
                                <div class="form-group col-4">
                                    <label>State <span class="clr_red"> * </span></label>

                                    <select formControlName="state" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.state.errors }"
                                        (change)="onChangeState($event)">
                                        <option [selected]="true" value="" [disabled]="true">Select State
                                        </option>
                                        <option *ngFor="let country of state" [value]="country.State">
                                            {{ country.State }}
                                        </option>
                                    </select>
                                    <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                                        <div *ngIf="f.state.errors.required">Select Your State</div>
                                    </div>
                                </div>

                                <div class="form-group col-4">
                                    <label>District <span class="clr_red"> * </span></label>

                                    <select formControlName="district" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.district.errors }"
                                        (change)="onChangeDistrict($event)">
                                        <option [selected]="true" value="" [disabled]="true">Select District
                                        </option>
                                        <option *ngFor="let country of district" [value]="country.district">
                                            {{ country.district}}
                                        </option>
                                    </select>
                                    <div *ngIf="submitted && f.district.errors" class="invalid-feedback">
                                        <div *ngIf="f.district.errors.required">Select Your District</div>
                                    </div>
                                </div>

                                <div class="form-group col-4">
                                    <label>ITI Code (Enter ITI Code if not found in list)</label>

                                    <input *ngIf="bool_iti_text" type="text" formControlName="iticode" class="form-control"
                                         maxlength="50"
                                        placeholder="Enter Your ITI code"  />
                                    <select *ngIf="bool_iti_select" (change)="entry_iti($event)" formControlName="iticode" class="form-control"
                                       >
                                       <option value="Enter ITI Code" >Enter ITI Code
                                      </option>
                                        <option [selected]="true" value="" [disabled]="true">Select ITI Code
                                        </option>
                                        <option *ngFor="let city of iticode" [value]="city.iticode">
                                            {{ city.iticode }}
                                        </option>
                                    </select>
                                    <!-- <div *ngIf="submitted && f.iticode.errors" class="invalid-feedback">
                                        <div *ngIf="f.iticode.errors.required">
                                            Select Your ITI code
                                        </div>
                                    </div> -->
                                </div>

                                <!-- <div class="form-group col-3">
                                    <label>Trade</label>
                                    <select formControlName="trade" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.trade.errors }">
                                        <option [selected]="true" value="" [disabled]="true">Select Trade</option>
                                        <option *ngFor="let trad of trade" [value]="trad.trade">
                                            {{ trad.trade }}
                                        </option>
                                    </select>
                                    <div *ngIf="submitted && f.trade.errors" class="invalid-feedback">
                                        <div *ngIf="f.trade.errors.required">
                                            Select Your Trade
                                        </div>
                                    </div>
                                </div> -->




                            </div>

                            <div class="form-row">

                                <div class="form-group col-4">
                                    <label>Name <span class="clr_red"> * </span></label>
                                    <input type="text" formControlName="name" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.name.errors }" maxlength="50"
                                        placeholder="Enter Your Name" (keypress)="omit_text($event)" />
                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name.errors.required">Enter Your Name</div>
                                    </div>
                                </div>

                                <div class="form-group col-4">
                                    <label>Email Id <span class="clr_red"> * </span></label>
                                    <input type="text" formControlName="email" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.email.errors }" maxlength="50"
                                        placeholder="Enter Your Email Address" (keypress)="omit_email($event)" />
                                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                        <div *ngIf="f.email.errors.required">Enter Your Email Id</div>
                                        <div *ngIf="f.email.errors.pattern">
                                            Enter Your Email Id must be a Valid Address
                                        </div>

                                    </div>
                                </div>

                                <div class="form-group col-4">
                                    <label>Mobile Number <span class="clr_red"> * </span></label>
                                    <input type="text" formControlName="mobileno" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.mobileno.errors }" maxlength="10"
                                        placeholder="Enter Your Mobile Number" (keypress)="omit_number($event)" />
                                    <div *ngIf="submitted && f.mobileno.errors" class="invalid-feedback">
                                        <div *ngIf="f.mobileno.errors.required">
                                            Enter Your Mobile Number
                                        </div>
                                        <div *ngIf="f.mobileno.errors.pattern">
                                            Enter Your Valid Mobile Number
                                        </div>
                                    </div>

                                    <!-- <div *ngIf="submitted && f.mobileno.errors" class="invalid-feedback">
                              <div *ngIf="f.mobileno.errors.max"> Mobile no must 10 digit</div>
                          </div> -->
                                </div>

                                <div class="form-group col-4">
                                    <label>CC Refernce Number <span class="clr_red"> * </span></label>
                                    <input type="text" formControlName="ccrefno" class="form-control" 
                                     (change)="cc_check($event)" maxlength="12" [ngClass]="{ 'is-invalid': submitted && f.ccrefno.errors }" 
                                        placeholder="Enter CC Ref Number 110179462821 "
                                        (keypress)="omit_number($event)" />
                                    <div *ngIf="submitted && f.ccrefno.errors" class="invalid-feedback">
                                        <div *ngIf="f.ccrefno.errors.required">
                                            Enter Your CC Refernce number
                                        </div>
                                    </div>
                                    <div *ngIf="submitted && f.ccrefno.errors" class="invalid-feedback">
                                        <div *ngIf="f.ccrefno.errors.pattern">
                                            Enter Your CC Refernce number Only Number
                                        </div>
                                    </div>

                                    <input type="text" formControlName="ccrefnostatus" hidden class="form-control"
                                    
                                    placeholder="Enter CC Ref status "
                                     />
                                <!-- <div *ngIf="submitted && f.ccrefnostatus.errors" class="invalid-feedback">
                                    <div *ngIf="f.ccrefnostatus.errors.required">
                                         Wait CC Refernce number status
                                    </div>
                                </div> -->

                                </div>


                                <div class="form-group col-4">
                                    <label>Order Id <span class="clr_red"> * </span></label>
                                    <input type="text" formControlName="orderid" class="form-control" maxlength="50"
                                        [placeholder]="var_placeholder" [ngClass]="{ 'is-invalid': submitted && f.orderid.errors }"  />
                                    <div *ngIf="submitted && f.orderid.errors" class="invalid-feedback">
                                        <div *ngIf="f.orderid.errors.required">
                                            Enter Your Order Id
                                        </div>
                                    </div>
                                    <!-- <div *ngIf="submitted && f.orderid.errors" class="invalid-feedback">
                                        <div *ngIf="f.orderid.errors.pattern">
                                            Enter Your Order Id Only Number
                                        </div>
                                    </div> -->
                                </div>

                                <div class="form-group col-4">
                                    <label>Payment Date <span class="clr_red"> * </span></label>
                                    <!-- <input type="date" formControlName="date" pattern="\d{4}-\d{2}-\d{2}"  class="form-control" [ngClass]="{ 'is-invalid': submitted && f.date.errors }" /> -->
                                    <!-- <mat-form-field>
                            <input matInput placeholder="Choose a date">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                          </mat-form-field> -->

                                    <!-- <dp-date-picker theme="dp-material" class=" date_cus" [config]="datePickerConfig" required="true" formControlName="date" [ngClass]="{ 'is-invalid': submitted && f.date.errors }" [disabled]="true"> </dp-date-picker> -->

                                    <!-- <input name="someName" [disabled]="false" theme="dp-material" class="form-control" formControlName="date"  [dpDayPicker]="datePickerConfig" [ngClass]="{ 'is-invalid': submitted && f.date.errors }"/> -->

                                    <input theme="dp-material" class="form-control" formControlName="date"
                                        [dpDayPicker]="datePickerConfig"
                                        [ngClass]="{ 'is-invalid': submitted && f.date.errors }"
                                        placeholder="Enter Payment Date" maxlength="10"  (keypress)="omit_all($event)" />

                                    <div *ngIf="submitted && f.date.errors" class="invalid-feedback">
                                        <div *ngIf="f.date.errors.required">
                                            Choose Your Payment Date
                                        </div>
                                    </div>
                                </div>




                                <div class="form-group col-12">
                                    <label>Any Other Additional Information</label>
                                    <textarea formControlName="descreption" class="form-control" [ngClass]="{
                      'is-invalid': submitted && f.descreption.errors
                    }" rows="3" (keypress)="omit_spl($event)" maxlength="500" style="resize: none;">

                    </textarea>
                                    <!-- <input
                      type="text"
                      formControlName="descreption" class="form-control"
                    [ngClass]="{
                      'is-invalid': submitted && f.descreption.errors
                    }"

                    /> -->

                                    <div *ngIf="submitted && f.descreption.errors" class="invalid-feedback">
                                        <div *ngIf="f.descreption.errors.maxLength">
                                            Enter Your Description
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group form-check">
                                    <input type="checkbox" formControlName="acceptTerms" id="acceptTerms"
                                        class="form-check-input" [ngClass]="{
                        'is-invalid': submitted && f.acceptTerms.errors
                      }" />
                                    <label for="acceptTerms" class="form-check-label">I agree that all the above
                                        information are correct</label>
                                    <div *ngIf="submitted && f.acceptTerms.errors" class="invalid-feedback">
                                    </div>
                                </div>

                                <div class="form-group col-12">
                                    <div class="text-center">
                                        <button class="btn btn-primary mr-1">Submit</button>
                                        <button class="btn btn-secondary" type="reset" (click)="onReset()">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>


                    <div class="card-body" *ngIf="bool_nimiForm">
                      <h2>Direct Deposit in NIMI Account  </h2>
                      <form [formGroup]="nimiForm" (ngSubmit)="onnimiSubmit()">
                        <div class="form-row">
                            <div class="col-md-4">
                                <label style="display: block; text-align: left;">Type of Payment Done </label>
                                <div style="text-align: left;">
                                    <input type="radio" value="radio1" formControlName="radiobtn"
                                        [(ngModel)]="readioSelected" (change)="showContent(readioSelected)" />
                                    <span> Bulk </span>
                                    <input type="radio" value="radio2" formControlName="radiobtn"
                                        [(ngModel)]="readioSelected" (change)="showContent(readioSelected)" />
                                    <span> Single </span>
                                    <input type="radio" value="radio3" formControlName="radiobtn"
                                        [(ngModel)]="readioSelected" (change)="showContent(readioSelected)" />
                                    <span> Direct NIMI </span>
                                </div>
                                <div *ngIf="submitted && n.radiobtn.errors" class="invalid-feedback">
                                    <div *ngIf="n.radiobtn.errors.required">
                                        Choose Your Payment Type
                                    </div>
                                </div>
                            </div>

                            <div  class="form-group col-12">

                                <div class="row">
                                    <div class="form-group col-6">
                                        <label>Number of Students <span class="clr_red"> * </span></label>
                                        <input type="text" formControlName="niminumberofstud" class="form-control"
                                            [ngModel]="niminumberStud" [ngClass]="{
                      'is-invalid': submitted && n.niminumberofstud.errors  }" maxlength="2" (keyup)="onnimiKey($event)" (change)="nimitest($event)" maxlength="3"
                                            placeholder="Enter Number of Students"
                                            (keypress)="omit_number($event)" />
                                        <div *ngIf="submitted && n.niminumberofstud.errors" class="invalid-feedback">
                                            <div *ngIf="n.niminumberofstud.errors.required">
                                                Enter Number of Students
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-6">
                                        <label>Total Amount</label>
                                        <input [attr.disabled]='true' type="text" formControlName="amount"
                                            [(ngModel)]="totAmount" class="form-control" [ngClass]="{
                      'is-invalid': submitted && n.amount.errors
                    }" placeholder="Total Amount" />
                                        <div *ngIf="submitted && n.amount.errors" class="invalid-feedback">
                                            <div *ngIf="n.amount.required">
                                                Enter Your Amount
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-12">
                                        <div class="table table-bordered" formArrayName="nimiqualification"
                                            style="text-align: center;">

                                            <div *ngFor="let Quantity of nimiqualificationFormGroups; let i=index"
                                                [formGroupName]="i">


                                                <input type="text" formControlName="nimibukregno" class="form-control"
                                                     maxlength="12" (keypress)="omit_number($event)"
                                                    placeholder="Enter Your Register Number">
                                                <p *ngIf="Quantity.controls.nimibukregno.errors?.required" style="font-size: 80%;
                                                color: #dc3545;">Enter Your Register Number
                                                </p>
                                                <p *ngIf="Quantity.controls.nimibukregno.errors?.pattern" style="font-size: 80%;
                                                color: #dc3545;">Enter Your 12 digit valid Register Number
                                                </p>


                                            </div>
                                        </div>



                                    </div>

                                </div>



                            </div>

                        </div>

                        <hr>

                        <div class="form-row">
                            <div class="form-group col-4">
                                <label>State <span class="clr_red"> * </span></label>

                                <select formControlName="state" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && n.state.errors }"
                                    (change)="onChangeState($event)">
                                    <option [selected]="true" value="" [disabled]="true">Select State
                                    </option>
                                    <option *ngFor="let country of state" [value]="country.State">
                                        {{ country.State }}
                                    </option>
                                </select>
                                <div *ngIf="submitted && n.state.errors" class="invalid-feedback">
                                    <div *ngIf="n.state.errors.required">Select Your State</div>
                                </div>
                            </div>


                        </div>

                        <div class="form-row">

                            <div class="form-group col-4">
                                <label>Name <span class="clr_red"> * </span></label>
                                <input type="text" formControlName="name" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && n.name.errors }" maxlength="50"
                                    placeholder="Enter Your Name" (keypress)="omit_text($event)" />
                                <div *ngIf="submitted && n.name.errors" class="invalid-feedback">
                                    <div *ngIf="n.name.errors.required">Enter Your Name</div>
                                </div>
                            </div>

                            <div class="form-group col-4">
                                <label>Email Id <span class="clr_red"> * </span> </label>
                                <input type="text" formControlName="email" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && n.email.errors }" maxlength="50"
                                    placeholder="Enter Your Email Address" (keypress)="omit_email($event)" />
                                <div *ngIf="submitted && n.email.errors" class="invalid-feedback">
                                    <div *ngIf="n.email.errors.required">Enter Your Email Id</div>
                                    <div *ngIf="n.email.errors.pattern">
                                        Enter Your Email Id must be a Valid Address
                                    </div>

                                </div>
                            </div>

                            <div class="form-group col-4">
                                <label>Mobile Number <span class="clr_red"> * </span> </label>
                                <input type="text" formControlName="mobileno" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && n.mobileno.errors }" maxlength="10"
                                    placeholder="Enter Your Mobile Number" (keypress)="omit_number($event)" />
                                <div *ngIf="submitted && n.mobileno.errors" class="invalid-feedback">
                                    <div *ngIf="n.mobileno.errors.required">
                                        Enter Your Mobile Number
                                    </div>
                                </div>
                                <div *ngIf="submitted && n.mobileno.errors" class="invalid-feedback">
                                  <div *ngIf="n.mobileno.errors.pattern">
                                    Enter valid Mobile Number
                                  </div>
                              </div>

                                <div *ngIf="submitted && n.mobileno.errors" class="invalid-feedback">
                          <div *ngIf="n.mobileno.errors.max"> Mobile no must 10 digit</div>
                      </div>
                            </div>

                            <div class="form-group col-4">
                              <label>Payment Method <span class="clr_red"> * </span> </label>

                              <select (change)="pay_change($event)" formControlName="paymethod" class="form-control"
                              [ngClass]="{ 'is-invalid': submitted && n.paymethod.errors }"
                            >
                              <option [selected]="true" value="" [disabled]="true">Select
                              </option>

                              <option value="Cash Deposit" >Cash Deposit </option>
                              <option value="NEFT/RTGS" >NEFT/RTGS </option>
                              <option value="IMPS" >IMPS </option>


                          </select>

                          <div *ngIf="submitted && n.paymethod.errors" class="invalid-feedback">
                            <div *ngIf="n.paymethod.errors.required">
                              Payment Method required
                            </div>
                        </div>

                          </div>

                            <div class="form-group col-4" *ngIf="!bool_photo">
                              <label> UTR / Transcation Number <span class="clr_red"> * </span></label>
                              <input type="text" formControlName="utr" class="form-control" maxlength="30"
                                  placeholder="Enter Your Transction Number" (change)="utr_check($event)"    [ngClass]="{ 'is-invalid': submitted && n.utr.errors }"
                                   />
                                   <div *ngIf="submitted && n.utr.errors" class="invalid-feedback">
                                    <div *ngIf="n.utr.errors.required">
                                      UTR / Transcation Number
                                    </div>
                                </div>

                          </div>

                            <div class="form-group col-4"  *ngIf="!bool_photo">
                                <label>Associated Mobile Number <span class="clr_red"> * </span></label>
                                <input type="text" (keypress)="omit_number($event)" formControlName="ascmob" class="form-control" maxlength="10"
                                    placeholder="Enter Associated Mobile Number"  [ngClass]="{ 'is-invalid': submitted && n.ascmob.errors }"
                                     />

                                     <div *ngIf="submitted && n.ascmob.errors" class="invalid-feedback">
                                      <div *ngIf="n.ascmob.errors.required">
                                        Enter Associated Mobile Number
                                      </div>
                                  </div>
                                  <div *ngIf="submitted && n.ascmob.errors" class="invalid-feedback">
                                    <div *ngIf="n.ascmob.errors.pattern">
                                      Enter valid Mobile Number
                                    </div>
                                </div>

                            </div>

                            <div class="form-group col-4">
                                <label>Payment / Transction Date <span class="clr_red"> * </span> </label>


                                <input theme="dp-material" class="form-control" formControlName="date"
                                    [dpDayPicker]="datePickerConfigDir"
                                    [ngClass]="{ 'is-invalid': submitted && n.date.errors }"
                                    placeholder="Enter Payment Date" maxlength="10" (keypress)="omit_all($event)" />

                                <div *ngIf="submitted && n.date.errors" class="invalid-feedback">
                                    <div *ngIf="n.date.errors.required">
                                        Choose Your Payment Date
                                    </div>
                                </div>
                            </div>


                            <div class="form-group col-4" *ngIf="bool_photo">
                              <label>Upload Deposit Chellan Copy  *</label>
                              <input type="file" id="customFile" class="form-control " name="uploadedPhoto"
                                  (change)="onFileSelectPhoto($event)" accept="image/x-png,image/jpeg, image/jpg" data-max-size="111"
                                  #uploadPhotoInput>
                              <!-- <img [src]="fileArraData" class="img-fluid" alt="" srcset="" style="width: 60px; "> -->
                              <!-- <input type="text" formControlName='image'>

                                  <div *ngIf="submitted && f.image.errors" class="invalid-feedback">
                                  <div *ngIf="f.image.errors.required">image is required</div>
                              </div> -->
                          </div>






                            <div class="form-group col-12">
                                <label>Any Other Additional Information</label>
                                <textarea formControlName="descreption" class="form-control" [ngClass]="{
                  'is-invalid': submitted && n.descreption.errors
                }" rows="3" (keypress)="omit_spl($event)" maxlength="500" style="resize: none;">

                </textarea>


                                <div *ngIf="submitted && n.descreption.errors" class="invalid-feedback">
                                    <div *ngIf="n.descreption.errors.maxLength">
                                        Enter Your Description
                                    </div>
                                </div>
                            </div>
                            <div class="form-group form-check">
                                <input type="checkbox" formControlName="acceptTerms" id="acceptTerms"
                                    class="form-check-input" [ngClass]="{
                    'is-invalid': submitted && n.acceptTerms.errors
                  }" />
                                <label for="acceptTerms" class="form-check-label">I agree that all the above
                                    information are correct</label>
                                <div *ngIf="submitted && n.acceptTerms.errors" class="invalid-feedback">
                                </div>
                            </div>

                            <div class="form-group col-12">
                                <div class="text-center">
                                    <button class="btn btn-primary mr-1">Submit</button>
                                    <button class="btn btn-secondary" type="reset" (click)="onReset()">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                  </div>

                </div>
            </div>


            <div class="eriformr_res_cls" *ngIf="bool_pri_result">
                <p>Your Complaint has been Sucessfully Registered. </p>
                <p>Your Ticket ID is <b> {{pri_genrateid}} </b> </p>
                <p>An Confirmation Email has been sent to your Registered Email Id </p>
                <p>The Status of your Complaint can be Tracked at <button (click)="track_fn()"
                        class="track_btn_cls">Track
                        Your complaint </button> </p>
                <!-- <p>To Raise Exam Related Issue Click Here <button class="track_btn_cls" (click)="pri_again_fn()"> Exam
                        Related
                        Issue </button> </p> -->
                <p>To Raise Exam Related Issue Click Here <button class="track_btn_cls" routerLink="/crs"
                        routerLinkActive="active"> Exam
                        Related
                        Issue </button> </p>
            </div>


        </div>
    </div>




</div>
